import React, { useState } from 'react';
import styled from 'styled-components';
import { bool, string } from 'prop-types';
import { H4 } from 'TMComponents/Typography';
import ContentParser from 'TMComponents/ContentParser';
import ChevronRight from '../../Icons/ChevronRight';
import { themeObj } from '../../GlobalStyle';
import { spacing } from '../../../designSystem/spacing';

const Wrapper = styled.div`
    background: white;
    border-radius: ${spacing.medium};
    box-shadow: 0px 4px 23px rgba(0, 48, 87, 0.1);
    padding: ${spacing.medium};

    &:last-child {
        margin-bottom: 0;
    }
`;

const AccordionTitle = styled(H4)`
    margin: 0;
    max-width: 400px;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${themeObj.colorSystem.primary[1]};
    word-wrap: break-word;
    hyphens: auto;
`;

const AccordionContent = styled(ContentParser)`
    p {
        padding-top: ${spacing.small};
        box-sizing: border-box;
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        color: ${themeObj.colorSystem.primary[1]};
    }

    a {
        color: ${themeObj.colorSystem.cta[3]};
        font-weight: 700;
        text-decoration: underline;
    }
`;

const TitleWrapper = styled.button`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: ${spacing.medium};
    width: 100%;
    margin-bottom: 0px !important;
    background: none;
    border: 0;
    cursor: pointer;
    text-align: left;
    color: unset;
`;

const Icon = styled(ChevronRight)`
    width: ${spacing.medium};
    height: ${spacing.medium};
    flex-shrink: 0;
    margin-top: ${spacing.tiny};
    text-align: right;
    transform: rotate(90deg);
    transition: all 0.3s ease;
    color: ${themeObj.colorSystem.primary[1]};

    ${(props) =>
        props.spin &&
        `
      transform: rotate(-90deg);
    `}
`;

const Item = ({ open, title, summary }) => {
    const [active, setActive] = useState(open);

    const toggle = () => {
        setActive((prevActive) => !prevActive);
    };

    return (
        <Wrapper>
            <TitleWrapper onClick={toggle}>
                <AccordionTitle>{title}</AccordionTitle>
                <Icon spin={active} />
            </TitleWrapper>
            {active && <AccordionContent show={active} copy={summary} />}
        </Wrapper>
    );
};

Item.propTypes = {
    open: bool,
    title: string.isRequired,
    summary: string.isRequired
};

Item.defaultProps = {
    open: false
};

export default Item;
